import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " ID ", -1)
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "mb-0 pl-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, " PRO ", -1)
const _hoisted_12 = { class: "d-flex align-items-center gap-2" }
const _hoisted_13 = {
  key: 0,
  class: "mb-0 pl-2"
}
const _hoisted_14 = {
  key: 0,
  class: "badge badge-warning",
  style: {"color":"#333"}
}
const _hoisted_15 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_16 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "w-250px" }
const _hoisted_20 = { class: "paragraph" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_23 = { class: "h4 mb-8" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "paragraph" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Цена: ", -1)
const _hoisted_29 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Категория: ", -1)
const _hoisted_31 = { class: "paragraph" }
const _hoisted_32 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Местоположение: ", -1)
const _hoisted_34 = { class: "paragraph" }
const _hoisted_35 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "h6" }, " Страна происхождения: ", -1)
const _hoisted_37 = { class: "paragraph" }
const _hoisted_38 = {
  key: 3,
  class: "mb-8"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Характеристики: ", -1)
const _hoisted_40 = { class: "bordered" }
const _hoisted_41 = { class: "w-200px" }
const _hoisted_42 = { class: "paragraph mx-2" }
const _hoisted_43 = { class: "w-200px" }
const _hoisted_44 = { class: "paragraph mx-2" }
const _hoisted_45 = {
  key: 4,
  class: "mb-8 w-100"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Уточнение заказа: ", -1)
const _hoisted_47 = { class: "bordered w-100" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Тип заказа ")
], -1)
const _hoisted_49 = { class: "w-50" }
const _hoisted_50 = { class: "paragraph mx-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Объем заказа ")
], -1)
const _hoisted_52 = { class: "paragraph mx-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Доставка ")
], -1)
const _hoisted_54 = { class: "paragraph mx-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Aдрec дocтaвки ")
], -1)
const _hoisted_56 = { class: "paragraph mx-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Способ оплаты ")
], -1)
const _hoisted_58 = { class: "paragraph mx-2" }
const _hoisted_59 = {
  key: 5,
  class: "mb-4"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-6" }, " Описание: ", -1)
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = { class: "mb-4 w-100" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Объявление: ", -1)
const _hoisted_64 = { class: "w-100 bordered" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Создано: ")
], -1)
const _hoisted_66 = { class: "w-50" }
const _hoisted_67 = { class: "paragraph mx-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Обновлено: ")
], -1)
const _hoisted_69 = { class: "" }
const _hoisted_70 = { class: "paragraph mx-2" }
const _hoisted_71 = { class: "mb-4 w-100" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "h6 mb-4" }, " Юзер: ", -1)
const _hoisted_73 = { class: "bordered w-100" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Юзер: ")
], -1)
const _hoisted_75 = { class: "w-50" }
const _hoisted_76 = { class: "paragraph mx-2" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Зарегистрирован: ")
], -1)
const _hoisted_82 = { class: "" }
const _hoisted_83 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", { class: "" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Авторизован: ")
], -1)
const _hoisted_85 = { class: "" }
const _hoisted_86 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_87 = {
  class: "",
  style: {"vertical-align":"middle","line-height":"1.2"}
}
const _hoisted_88 = { class: "paragraph mx-2" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Все объявления юзера: ")
const _hoisted_90 = { class: "py-0" }
const _hoisted_91 = { class: "w-100" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Активных: ")
], -1)
const _hoisted_93 = { class: "" }
const _hoisted_94 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "paragraph mx-2" }, " Отклонённых: ")
], -1)
const _hoisted_96 = { class: "" }
const _hoisted_97 = {
  key: 0,
  class: "paragraph mx-2"
}
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 2 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("p", null, " Не одобрялся ", -1)
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_111 = { class: "mb-2" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", null, " Не отклонялся ", -1)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = { class: "mb-2 w-180px" }
const _hoisted_120 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_121 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_122 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", null, " Аккаунт ", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("strong", null, " PRO ", -1)
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = { class: "paragraph" }
const _hoisted_127 = { key: 2 }
const _hoisted_128 = {
  key: 3,
  class: "paragraph"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("strong", null, " Зарегистрирован: ", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("span", null, " Создано ", -1)
const _hoisted_133 = { class: "paragraph" }
const _hoisted_134 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", null, " Изменено ", -1)
const _hoisted_136 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_137 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_138 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("span", null, " Цена ", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, [
    /*#__PURE__*/_createTextVNode(" Страна"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("происхождения ")
  ])
], -1)
const _hoisted_141 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_142 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-2 mb-0" }, [
    /*#__PURE__*/_createTextVNode(" Местонахождение"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("товара ")
  ])
], -1)
const _hoisted_144 = {
  key: 0,
  class: "paragraph"
}
const _hoisted_145 = {
  key: 1,
  class: "paragraph"
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document-add fs-3" }, null, -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
  title: "Редактировать"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-edit fs-3" }, null, -1)
const _hoisted_151 = ["onClick"]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-delete fs-3" }, null, -1)
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = {
  key: 0,
  class: "buttons-wrap"
}
const _hoisted_155 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_156 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" Удалить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_AgroPriceText = _resolveComponent("AgroPriceText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ads_filter = _resolveComponent("ads-filter")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ads_filter, {
        onFilterButtonClick: _ctx.filterButtonClick,
        "items-total": _ctx.newsPaginationItemsNumber,
        "pages-total": _ctx.newsPaginationPagesNumber,
        "current-page": _ctx.filterData.page
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_pre, {
            hide: "",
            title: "requestedNewsList",
            data: _ctx.requestedNewsList
          }, null, 8, ["data"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _ctx.requestedNewsList,
            "scrollbar-always-on": true,
            "table-layout": "fixed",
            "show-header": true,
            resizable: true
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, {
                "image-size": 300,
                description: "Ничего не найдено"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "top",
                class: "py-5 px-0 fw-bolder text-center min-w-50px align-top",
                width: _ctx.calcWidth(40),
                property: "checked"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.requestedNewsList.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedModel) = $event)),
                          class: "form-check-input",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchAllCheckboxes && _ctx.switchAllCheckboxes(...args)))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.checkedModel]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((scope.row.checked) = $event),
                      class: "form-check-input"
                    }, null, 8, _hoisted_5), [
                      [_vModelCheckbox, scope.row.checked]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                property: "id",
                label: "ID",
                width: _ctx.calcWidth(120)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortTheColumn('id')))
                    }, [
                      _hoisted_7,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState.id.dir,
                      'bi-sort-down': !_ctx.sortState.id.dir,
                      'opacity-25': _ctx.currentSort !== 'id' && _ctx.currentSort !== '-id',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x mr-2", {
                      'bi-patch-check-fill text-primary':
                        scope.row.status === 'confirmed',
                      'bi-patch-minus-fill text-danger':
                        scope.row.status === 'rejected',
                      'bi-patch-exclamation-fill text-warning':
                        scope.row.status === 'not_verified',
                    }]),
                        title: _ctx.generateNewsTitle(scope.row.status)
                      }, null, 10, _hoisted_9),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.id), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                label: "PRO",
                width: _ctx.calcWidth(70)
              }, {
                header: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      (scope.row.owner)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                            (scope.row.owner.account_pro)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " PRO "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(160),
                label: "Закреплено до"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.fixed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " FIXED "))
                      : _createCommentVNode("", true),
                    (scope.row.fixed_until && scope.row.fixed_until.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.dateConverter(scope.row.fixed_until)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 w-280px align-top",
                width: _ctx.calcWidth(280),
                label: "Фото"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_17, [
                    (scope.row.photos.length > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: 'news_carousel_' + scope.$index
                        }, [
                          _createVNode(_component_vue_easy_lightbox, {
                            scrollDisabled: false,
                            visible: scope.row.lightboxVisible,
                            imgs: scope.row.previewPhotos,
                            index: _ctx.currentImageId,
                            onHide: ($event: any) => (_ctx.closeLightbox(scope.$index))
                          }, null, 8, ["visible", "imgs", "index", "onHide"]),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.photos, (subitem, subindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: subindex,
                                class: _normalizeClass({ active: subindex === 0 })
                              }, [
                                _createVNode(_component_el_image, {
                                  id: `el-image-${subindex}`,
                                  style: {"width":"250px","height":"auto","cursor":"pointer"},
                                  src: subitem.path,
                                  onClick: ($event: any) => ([_ctx.toggleLightbox(scope.$index), _ctx.setCurrentImageId(subindex)])
                                }, null, 8, ["id", "src", "onClick"])
                              ], 2))
                            }), 128))
                          ])
                        ], 8, _hoisted_18))
                      : (_openBlock(), _createBlock(_component_el_skeleton_item, {
                          key: 1,
                          variant: "image",
                          class: "w-250px h-200px"
                        }))
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-5 align-top",
                width: _ctx.calcWidth(410),
                label: "Название"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["my-2 flex", _ctx.rowClasses])
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", null, [
                        (scope.row.type === 'demand')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Спрос "))
                          : _createCommentVNode("", true),
                        (scope.row.type === 'offer')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Предложение "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("h4", _hoisted_23, [
                      (scope.row.name && scope.row.name.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row.name), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, " Нет названия "))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_AgroPriceText, {
                          modelValue: scope.row.price,
                          measureName: scope.row.measure_name
                        }, null, 8, ["modelValue", "measureName"])
                      ])
                    ]),
                    (scope.row.rubric && scope.row.rubric.name && scope.row.rubric.name.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("span", _hoisted_31, [
                            _createVNode(_component_router_link, {
                              class: "underline text-success",
                              to: {
                        name: 'ads-list',
                        query: {
                          page: 1,
                          limit: 10,
                          'filter[status]': 'all',
                          'filter[rubric]': scope.row.rubric.id,
                          'filter[active]': 'active',
                        }
                      },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.rubric.fullPath), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.geo_name && scope.row.geo_name.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("span", _hoisted_34, _toDisplayString(scope.row.geo_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.country_of_origin && scope.row.country_of_origin.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("span", _hoisted_37, _toDisplayString(scope.row.country_of_origin), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row['rubric_props'] && scope.row['rubric_props'].length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("table", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row['rubric_props'], (prop, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_41, [
                                  _createElementVNode("p", _hoisted_42, _toDisplayString(prop.title), 1)
                                ]),
                                _createElementVNode("td", _hoisted_43, [
                                  _createElementVNode("p", _hoisted_44, _toDisplayString(prop.value), 1)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row['refine_order'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("table", _hoisted_47, [
                            _createElementVNode("tr", null, [
                              _hoisted_48,
                              _createElementVNode("td", _hoisted_49, [
                                _createElementVNode("p", _hoisted_50, _toDisplayString(scope.row.order['order_type']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_51,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_52, _toDisplayString(scope.row.order['order_quantity']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_53,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_54, _toDisplayString(scope.row.order['order_delivery_type']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_55,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_56, _toDisplayString(scope.row.order['order_delivery_address']), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_57,
                              _createElementVNode("td", null, [
                                _createElementVNode("p", _hoisted_58, _toDisplayString(scope.row.order['order_payment_method']), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.description && scope.row.description.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("div", {
                            class: "paragraph",
                            innerHTML: scope.row.description
                          }, null, 8, _hoisted_61)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("table", _hoisted_64, [
                        _createElementVNode("tr", null, [
                          _hoisted_65,
                          _createElementVNode("td", _hoisted_66, [
                            _createElementVNode("p", _hoisted_67, _toDisplayString(scope.row.created_at), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_68,
                          _createElementVNode("td", _hoisted_69, [
                            _createElementVNode("p", _hoisted_70, _toDisplayString(scope.row.modified_at), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("table", _hoisted_73, [
                        _createElementVNode("tr", null, [
                          _hoisted_74,
                          _createElementVNode("td", _hoisted_75, [
                            _createElementVNode("p", _hoisted_76, [
                              (scope.row.owner && scope.row.owner.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    target: "_blank",
                                    class: "underline text-success",
                                    to: {
                              name: 'users-edit',
                              params: {
                                id: scope.row.owner.id,
                              },
                            }
                                  }, {
                                    default: _withCtx(() => [
                                      (scope.row.owner.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(scope.row.owner.name), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                    (scope.row.owner && scope.row.owner.name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(scope.row.owner.name), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_80, " Нет имени "))
                                  ]))
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_81,
                          _createElementVNode("td", _hoisted_82, [
                            (scope.row.owner && scope.row.owner.registered_at)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(scope.row.owner.registered_at), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_84,
                          _createElementVNode("td", _hoisted_85, [
                            (scope.row.owner && scope.row.owner.last_login)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(scope.row.owner.last_login), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_87, [
                            _createElementVNode("p", _hoisted_88, [
                              (scope.row.owner && scope.row.owner.id)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "underline text-success",
                                    to: {
                              page: 1,
                              limit: 10,
                              'filter[status]': 'all',
                              'filter[user_id]': scope.row.owner.id,
                            },
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_89
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_90, [
                            _createElementVNode("table", _hoisted_91, [
                              _createElementVNode("tr", null, [
                                _hoisted_92,
                                _createElementVNode("td", _hoisted_93, [
                                  (scope.row.owner && scope.row.owner.stats && scope.row.owner.stats.ads)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString(scope.row.owner.stats.ads.active), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_95,
                                _createElementVNode("td", _hoisted_96, [
                                  (scope.row.owner && scope.row.owner.stats && scope.row.owner.stats.ads)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(scope.row.owner.stats.ads.rejected), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 align-top",
                width: _ctx.calcWidth(460),
                label: "Модерация"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог одобрений ${
                        scope.row.approved_log ? scope.row.approved_log.count : '0'
                      }`
                    ,
                          name: "1"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              (
                          scope.row.approved_log && scope.row.approved_log.count
                        )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                    (
                            scope.row.approved_log.log &&
                              scope.row.approved_log.log.length
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                          _hoisted_100,
                                          _createVNode(_component_el_timeline, null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approved_log.log, (reason, index) => {
                                                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                  key: index,
                                                  timestamp: reason.date
                                                }, {
                                                  default: _withCtx(() => [
                                                    (reason.moderator.id)
                                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                                          key: 0,
                                                          class: "underline text-success",
                                                          to: {
                                  name: 'users-edit',
                                  params: {
                                    id: reason.moderator.id,
                                  },
                                }
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (reason.moderator.name && reason.moderator.name.length)
                                                              ? (_openBlock(), _createElementBlock("strong", _hoisted_101, _toDisplayString(reason.moderator.name), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_102, " Нет имени "))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["to"]))
                                                      : (reason.moderator.name && reason.moderator.name.length)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(reason.moderator.name), 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_104, " Нет имени "))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["timestamp"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_105, _hoisted_107))
                            ])), [
                              [_directive_loading, scope.row.logApprovedProgress]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог отклонений ${
                        scope.row.rejected_log ? scope.row.rejected_log.count : '0'
                      }`
                    ,
                          name: "2"
                        }, {
                          default: _withCtx(() => [
                            (scope.row.rejected_log && scope.row.rejected_log.count)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  _createElementVNode("p", null, " Отклонено раз: " + _toDisplayString(scope.row.rejected_log.count), 1),
                                  (
                          scope.row.rejected_log.log &&
                            scope.row.rejected_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                        _hoisted_110,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.rejected_log.log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_111, _toDisplayString(reason.text), 1),
                                                  (reason.moderator.id)
                                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 0,
                                                        class: "underline text-success",
                                                        to: {
                                name: 'users-edit',
                                params: {
                                  id: reason.moderator.id,
                                },
                              }
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (reason.moderator.name && reason.moderator.name.length)
                                                            ? (_openBlock(), _createElementBlock("strong", _hoisted_112, _toDisplayString(reason.moderator.name), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_113, " Нет имени "))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["to"]))
                                                    : (reason.moderator.name && reason.moderator.name.length)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(reason.moderator.name), 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_115, " Нет имени "))
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_116, _hoisted_118))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    _createElementVNode("div", _hoisted_119, [
                      _createVNode(_component_el_checkbox_group, {
                        class: "my-2",
                        size: "small",
                        modelValue: scope.row.reasons,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.reasons) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reasonItem, reasonIndex) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: reasonIndex,
                              label: reasonItem,
                              class: "mb-4",
                              onChange: ($event: any) => (_ctx.checkItemOnReasonSelect(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reasonItem.value.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "onChange"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(140),
                label: "Категория"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (
                    scope.row.rubric &&
                    scope.row.rubric.name
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_120, _toDisplayString(scope.row.rubric.name), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170),
                label: "Юзер"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.owner && scope.row.owner.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_121, [
                          _createElementVNode("strong", null, _toDisplayString(scope.row.owner.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.owner && scope.row.owner.account_pro)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_122, _hoisted_125))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_126, _toDisplayString(scope.row.updated_at), 1),
                    (scope.row.author)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_127, _toDisplayString(scope.row.author.name), 1))
                      : _createCommentVNode("", true),
                    (scope.row.owner && scope.row.owner.registered_at)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_128, [
                          _hoisted_129,
                          _hoisted_130,
                          _createElementVNode("span", null, _toDisplayString(scope.row.owner.registered_at), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortTheColumn('created_at')))
                    }, [
                      _hoisted_132,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState['created_at'].dir,
                      'bi-sort-down': !_ctx.sortState['created_at'].dir,
                      'opacity-25': _ctx.currentSort !== 'created_at' && _ctx.currentSort !== '-created_at',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_133, _toDisplayString(scope.row.created_at), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortTheColumn('modified_at')))
                    }, [
                      _hoisted_135,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState['modified_at'].dir,
                      'bi-sort-down': !_ctx.sortState['modified_at'].dir,
                      'opacity-25': _ctx.currentSort !== 'modified_at' && _ctx.currentSort !== '-modified_at',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.modified_at && scope.row.modified_at.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_136, _toDisplayString(scope.row.modified_at), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_137, " Нет "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(220)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortTheColumn('price')))
                    }, [
                      _hoisted_139,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-black", {
                      'bi-sort-up': _ctx.sortState.price.dir,
                      'bi-sort-down': !_ctx.sortState.price.dir,
                      'opacity-25': _ctx.currentSort !== 'price' && _ctx.currentSort !== '-price',
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-center", _ctx.rowClasses])
                  }, [
                    _createVNode(_component_AgroPriceText, {
                      modelValue: scope.row.price,
                      measureName: scope.row.measure_name
                    }, null, 8, ["modelValue", "measureName"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170)
              }, {
                header: _withCtx(() => [
                  _hoisted_140
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.country_of_origin && scope.row.country_of_origin.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_141, _toDisplayString(scope.row.country_of_origin), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_142, " Пусто "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(180)
              }, {
                header: _withCtx(() => [
                  _hoisted_143
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.geo_name && scope.row.geo_name.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_144, _toDisplayString(scope.row.geo_name), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_145, " Пусто "))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                width: _ctx.calcWidth(60)
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createVNode(_component_el_button_group, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Одобрить",
                          onClick: ($event: any) => (_ctx.allowEntry(scope.row))
                        }, _hoisted_148, 8, _hoisted_146),
                        _createElementVNode("button", _hoisted_149, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'ads-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_150
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Удалить",
                          onClick: ($event: any) => (_ctx.deleteEntry(scope.row))
                        }, _hoisted_153, 8, _hoisted_151)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.adsLoading]
          ]),
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                _createVNode(_component_el_button, {
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.allowBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_155
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "warning",
                  title: _ctx.declineButtonTitle,
                  disabled: _ctx.bulkDeclineStatus,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rejectBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_156
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_157
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onFilterButtonClick", "items-total", "pages-total", "current-page"])
    ])
  ]))
}